import { Field } from '@atlassian/learning-components';
import React from 'react';

import { ContentfulLearningPath } from 'src/graphql/queries/GetLearningPath';
import { TagList } from 'src/components/TagList';

export const remapLearningPathTaxonomy = (learningPath: ContentfulLearningPath, duration: string): Field[] => [
  {
    name: 'duration',
    value: duration,
  },
  {
    name: 'role',
    value: learningPath.productRole?.length ? learningPath.productRole.join(', ') : '',
  },
  {
    name: 'level',
    value: learningPath.learningLevel,
  },
  {
    name: 'app',
    value: <TagList isLarge={false} taxonomyList={learningPath.product} />,
  },
];
